import PortalIdParser from 'PortalIdParser';
import PageLayoutComponent from 'in-meeting-experience-ui-components/components/pageLayout/PageLayout';
import { AppContext } from 'in-meeting-experience-ui-components/contexts/app/context';
import { ErrorContext } from 'in-meeting-experience-ui-components/contexts/error/context';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routes, unauthorizedRoutesParam } from '../constants/routes';
import { ATTENDEE_TABS, DEFAULT_TABS, TABS_ID } from '../constants/tabs';
import useTracker from '../hooks/useTracker';
import { resetStateBetweenCallObjects } from '../slices/app/actions';
import { currentAccountSelector, firstNameSelector, lastNameSelector } from '../slices/auth/selectors';
import { callObjectIdSelector, callObjectTitleSelector } from '../slices/callObject/selectors';
import { canViewParticipantsSelector, meetingIdSelector } from '../slices/google/selectors';
import { googleActions } from '../slices/google/slice';
import { meetingParticipantsSelector } from '../slices/participants/selectors';
import { isPreviousMeetingsMenuOpenSelector, recurringMeetingsSelector } from '../slices/recurringMeetings/selectors';
import { recurringMeetingsActions } from '../slices/recurringMeetings/slice';
import { jsx as _jsx } from "react/jsx-runtime";
const FOOTER_HEIGHT = '186px';
const FOOTER_HEIGHT_PAST_MEETING = '48px';
function PageLayout({
  children
}) {
  const dispatch = useDispatch();
  const {
    isApiCallObjectOutage,
    isExternalOutage
  } = useContext(ErrorContext);
  const {
    isPastMeeting
  } = useContext(AppContext);
  const {
    pathname
  } = useLocation();
  const [use, setUse] = useState('default');
  const [tabContainerHeight, setTabContainerHeight] = useState('');
  const firstName = useSelector(firstNameSelector);
  const lastName = useSelector(lastNameSelector);
  const isPreviousMeetingsMenuOpen = useSelector(isPreviousMeetingsMenuOpenSelector);
  const currentAccount = useSelector(currentAccountSelector);
  const recurringMeetings = useSelector(recurringMeetingsSelector);
  const callObjectId = useSelector(callObjectIdSelector);
  const meetingId = useSelector(meetingIdSelector);
  const meetingParticipants = useSelector(meetingParticipantsSelector);
  const canViewParticipants = useSelector(canViewParticipantsSelector);
  const callObjectTitle = useSelector(callObjectTitleSelector);
  const usageTracker = useTracker();
  const setMeetingContext = useCallback(data => {
    dispatch(googleActions.receiveMeetingContext(data));
  }, [dispatch]);
  const initMethod = useCallback(() => null, []);
  const resetStateBetweenCallObjectsHandler = useCallback(() => {
    dispatch(resetStateBetweenCallObjects());
  }, [dispatch]);
  const togglePreviousMeetingsMenuOpen = useCallback(value => {
    dispatch(recurringMeetingsActions.togglePreviousMeetingsMenuOpen(value));
  }, [dispatch]);
  useEffect(() => {
    setUse(pathname.includes(TABS_ID.comments) && !isExternalOutage ? 'dark' : 'default');
  }, [pathname, use, isExternalOutage]);
  useEffect(() => {
    if (pathname.includes(TABS_ID.comments) && !isExternalOutage) {
      if (isPastMeeting) {
        setTabContainerHeight(`calc(100% - ${FOOTER_HEIGHT_PAST_MEETING})`);
      } else {
        setTabContainerHeight(`calc(100% - ${FOOTER_HEIGHT})`);
      }
    } else {
      setTabContainerHeight('100%');
    }
  }, [pathname, dispatch, isExternalOutage, isPastMeeting]);
  return /*#__PURE__*/_jsx(PageLayoutComponent, {
    portalId: PortalIdParser.getPortalIdFromPath(),
    callObjectId: Number(callObjectId),
    recurringMeetings: recurringMeetings,
    currentAccount: currentAccount,
    unauthorizedRoutesParam: unauthorizedRoutesParam,
    routes: {
      comments: routes.comments,
      outsideMeeting: routes.outsideMeeting,
      draft: routes.draft,
      contacts: routes.contacts,
      associations: routes.associations,
      base: routes.base,
      accounts: routes.accounts
    },
    tabsConfig: canViewParticipants ? DEFAULT_TABS : ATTENDEE_TABS,
    setMeetingContext: setMeetingContext,
    initMethod: initMethod,
    meetingTopic: callObjectTitle,
    isPreviousMeetingsMenuOpen: isPreviousMeetingsMenuOpen,
    canViewParticipants: canViewParticipants !== null && canViewParticipants !== void 0 ? canViewParticipants : false,
    usageTracker: usageTracker,
    resetStateBetweenCallObjects: resetStateBetweenCallObjectsHandler,
    firstName: firstName,
    lastName: lastName,
    togglePreviousMeetingsMenuOpen: togglePreviousMeetingsMenuOpen,
    useTheme: use,
    tabContainerHeight: tabContainerHeight,
    participants: meetingParticipants,
    meetingID: meetingId,
    showHeader: !isApiCallObjectOutage,
    children: children
  });
}
export default PageLayout;